import snackbar from "components/snackbar";
import setLoading from 'components/loading';


export default {
    'ModalBody.ButtonsWrapper.OverrideButton': ({ }, stateManager) => {
        stateManager.setSelectedTabId("occupants")
        stateManager.setIsEmailExist(false)
    },
    'ModalBody.ButtonsWrapper.SendEmailButton': ({ }, stateManager) => {
        const { property, isEmailExist } = stateManager.store.getState()
        const { email, pin } = isEmailExist

        const payload = {
            pin,
            email,
            property_id: property?.id,
            client_schema: window.CLIENT_SCHEMA,
        }

        setLoading(true)
        stateManager.saveSendEmail(payload)
            .then(() => {
                setLoading(false)
                snackbar({
                    message: "Email is sent!",
                    args: { type: 'success' }
                })


                stateManager.setIsEmailExist({
                    ...isEmailExist,
                    emailExist: false,
                })
            })
            .catch((e) => {
                setLoading(false)
                snackbar({
                    message: e?.response?.data?.error || e?.message,
                    args: { type: 'error' }
                })

                stateManager.setIsEmailExist({
                    ...isEmailExist,
                    emailExist: false,
                })
            })
    }
}

